
import { CargoV2SearchFlight } from "@/domain/entities/CargoV2";
import moment from "moment";
import { Vue, Options, prop } from "vue-class-component";
import { getAirportIcon } from "../../modules/airport-icons-circle";

class Props {
  flight = prop<CargoV2SearchFlight>({
    default: new CargoV2SearchFlight(),
    type: CargoV2SearchFlight,
  });
  modelValue = prop<boolean>({
    default: false,
    type: Boolean,
  });
}

@Options({
  emits: ["save", "update:modelValue", "close"],
})
export default class ModalDelayConfirmation extends Vue.with(Props) {
  get selectedFirstFlight() {
    return this.flight.itineraries[0];
  }

  get departureHours() {
    const totalMinutes = moment(this.flight.departureDate).diff(
      moment(),
      "minutes",
    );
    return Math.max(0, Math.floor(totalMinutes / 60));
  } 
  get departureMinutes() {
    const totalMinutes = moment(this.flight.departureDate).diff(
      moment(),
      "minutes",
    );
    return Math.max(0, totalMinutes % 60);
  }

  get airportIcon() {
    return getAirportIcon(this.selectedFirstFlight?.flightNo.toUpperCase());
  }

  formatDepartureDate(date: string) {
    const dateValue = moment(date).format("DD MMM YYYY");
    const timeValue = moment(date).format("HH:mm");
    return `${dateValue} • ${timeValue}`;
  }

  closeModal() {
    this.$emit("update:modelValue", false);
    this.$emit("close");
  }

  onSave(flight: CargoV2SearchFlight) {
    this.$emit("save", flight);
  }
}
